import { Navigate } from 'react-router-dom'

export function ProfilePage() {
  // Redirect to admin panel for account management
  return <Navigate to="/?subdomain=admin" replace />
}
